import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import Mascot from "../components/Mascot";
import SquishyButton from "../components/SquishyButton";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function ParentLogin() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    const res = mode === "login" ? await login(email, password) : await register(email, password, name);
    setBusy(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-sky-50 flex flex-col items-center px-4 py-8">
      <button data-testid="parent-back-btn" onClick={() => navigate("/")}
              className="self-start flex items-center gap-2 rounded-full bg-white px-4 py-2 font-bold text-slate-500 shadow">
        <ArrowLeft className="h-4 w-4" /> Terug
      </button>

      <div className="mt-6 flex flex-col items-center">
        <Mascot mood="idle" size={110} message="Dit is de ouder-omgeving." showBubble={false} />
        <div className="mt-2 flex items-center gap-2 rounded-full bg-emerald-100 px-4 py-1.5 text-emerald-700">
          <ShieldCheck className="h-5 w-5" />
          <span className="font-display font-bold">Ouder-omgeving</span>
        </div>
      </div>

      <motion.form
        initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
        onSubmit={submit}
        className="mt-6 w-full max-w-sm space-y-4 rounded-[2rem] bg-white p-6 shadow-xl"
      >
        <h1 className="text-center font-display text-2xl font-bold text-slate-800">
          {mode === "login" ? "Inloggen" : "Account maken"}
        </h1>

        {mode === "register" && (
          <input data-testid="parent-name-input" value={name} onChange={(e) => setName(e.target.value)}
                 placeholder="Naam" className="w-full rounded-2xl border-2 border-slate-200 px-4 py-3 font-bold outline-none focus:border-sky-400" />
        )}
        <input data-testid="parent-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
               placeholder="E-mailadres" className="w-full rounded-2xl border-2 border-slate-200 px-4 py-3 font-bold outline-none focus:border-sky-400" />
        <input data-testid="parent-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
               placeholder="Wachtwoord" className="w-full rounded-2xl border-2 border-slate-200 px-4 py-3 font-bold outline-none focus:border-sky-400" />

        {error && <p data-testid="parent-auth-error" className="text-center text-sm font-bold text-red-500">{error}</p>}

        <SquishyButton data-testid="parent-submit-btn" type="submit" disabled={busy} color="#4ADE80" edge="#16A34A" className="w-full text-lg">
          {busy ? "Even geduld..." : mode === "login" ? "Inloggen" : "Account maken"}
        </SquishyButton>

        <button type="button" data-testid="parent-toggle-mode" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
                className="w-full text-center text-sm font-bold text-sky-500">
          {mode === "login" ? "Nog geen account? Maak er een aan" : "Al een account? Log in"}
        </button>
      </motion.form>
    </div>
  );
}
